<app-page-header [title]="'Gestión Financiera'" [subtitle]="'Eventos'"></app-page-header>
<div class="card">
    <p-tabView
      styleClass="tabview-custom"
      [(activeIndex)]="modalitieTabIndex"
      (onChange)="onModalitieTabChange($event)"
    >
      <p-tabPanel header="MANUAL_VALIDATION">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i class="pi pi-check-circle" style="font-size: 1.5rem"></i>
            <span class="font-bold white-space-nowrap m-0">
              Verificación de Pagos Manuales
            </span>
          </div>
        </ng-template>
        <div *ngIf="showPaymenManualValidation" class="p-mt-2">
          <p-toast />
  
          <p-table
            #dt
            [value]="registrationsByPayment"
            [rows]="10"
            [paginator]="true"
            [globalFilterFields]="['clubName']"
            [rowHover]="true"
            dataKey="id"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true"
            class="p-datatable-sm table'"
          >
            <ng-template pTemplate="caption">
              <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">Inscripciones pendientes de verificación</h5>
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    (input)="
                      dt.filterGlobal($any($event.target).value, 'contains')
                    "
                    placeholder="Search..."
                  />
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name" class="table__header">
                      Club <p-sortIcon field="rating" />
                    </th>
                    <th pSortableColumn="idNumber" class="table__header">
                      Cantidad Inscritos Ordinarios <p-sortIcon field="name" />
                    </th>
                    <th pSortableColumn="name" class="table__header">
                      Valor Inscritos Ordinarios
                    </th>
                    <th pSortableColumn="lastName" class="table__header">
                      Cantidad Inscritos Extraordinarios <p-sortIcon field="price" />
                    </th>
              
                    <th pSortableColumn="birthDay" class="table__header">
                      Valor Inscritos Extraordinarios <p-sortIcon field="inventoryStatus" />
                    </th>
              
                    <th pSortableColumn="level" class="table__header">
                      Valor Inscripción Club <p-sortIcon field="inventoryStatus" />
                    </th>
              
                    <th pSortableColumn="level" class="table__header">
                      Total a Pagar <p-sortIcon field="inventoryStatus" />
                    </th>
                    <th pSortableColumn="level" class="table__header">
                     Acciones <p-sortIcon field="inventoryStatus" />
                    </th>
                  </tr>
            </ng-template>
            <ng-template pTemplate="body" let-registrationByPayment>
                <tr class="table__row">
                    <td>
                      {{ getClub(registrationByPayment.clubId)?.name }}
                    </td>
              
                    <td>{{ getRegistrations(registrationByPayment.paymentId, 'ORDINARY').length }}</td>
                    <td>
                      {{ calculateAmount(registrationByPayment.paymentId, 'ORDINARY') }}
                    </td>
                    <td>{{ getRegistrations(registrationByPayment.paymentId, 'EXTRAORDINARY').length }}</td>
                    <td>
                      {{ calculateAmount(registrationByPayment.paymentId, 'EXTRAORDINARY') }}
                    </td>
                    <td>
                      {{ getClubAmount(registrationByPayment.paymentId) }}
                    </td>
                    <td>
                      {{ calculateTotalAmount(registrationByPayment.paymentId) }}
                    </td>
                  
                <td>
                  <p-button
                    icon="pi pi-users"
                    [rounded]="true"
                    [text]="true"
                    severity="info"
                    [raised]="true"
                    class="table__button"
                    pTooltip="Inscripciones Asociadas"
                    tooltipPosition="bottom"
                    (onClick)="openRegistrations(registrationByPayment)"
                  />
  
                  <p-button
                    icon="pi pi-file"
                    [rounded]="true"
                    [text]="true"
                    [raised]="true"
                    severity="warning "
                    class="table__button"
                    pTooltip="Ver Soporte"
                    tooltipPosition="bottom"
                    (onClick)="showSupport(registrationByPayment)"
                  />
  
                  <p-button
                    icon="pi pi-check-circle"
                    [rounded]="true"
                    [text]="true"
                    [raised]="true"
                    severity="success"
                    class="table__button"
                    pTooltip="Emitir Concepto"
                    tooltipPosition="bottom"
                    (onClick)="validateRegistration(registrationByPayment)"
                  />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between">
                {{ registrationsByPayment ? registrationsByPayment.length : 0 }}
                solicitudes en total.
              </div>
            </ng-template>
          </p-table>
        </div>
      </p-tabPanel>
      <p-tabPanel header="VERIFICATION_HISTORY">
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2">
            <i class="pi pi-book" style="font-size: 1.5rem"></i>
            <span class="font-bold white-space-nowrap m-0"
              >Historial de Verificaciones</span
            >
          </div>
        </ng-template>
        <div *ngIf="showVerificationHistory" class="p-mt-2">
          <p-toast />

          <p-table
            #dtHistory
            [value]="filteredVerifiedPayments"
            [rows]="10"
            [paginator]="true"
            [globalFilterFields]="[
              'clubName',
              'competitionName',
              'paymentId',
              'statusLabel',
              'verifiedBy'
            ]"
            [rowHover]="true"
            dataKey="paymentId"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true"
            styleClass="p-datatable-sm"
          >
            <ng-template pTemplate="caption">
              <div class="history-caption">
                <h5 class="m-0">Pagos manuales ya verificados</h5>
                <div class="history-caption__tools">
                  <p-selectButton
                    [options]="historyStatusOptions"
                    [(ngModel)]="historyStatusFilter"
                    (onChange)="applyHistoryFilter()"
                    optionLabel="label"
                    optionValue="value"
                  />
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      (input)="
                        dtHistory.filterGlobal(
                          $any($event.target).value,
                          'contains'
                        )
                      "
                      placeholder="Search..."
                    />
                  </span>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="clubName" class="table__header">
                  Club <p-sortIcon field="clubName" />
                </th>
                <th pSortableColumn="competitionName" class="table__header">
                  Evento <p-sortIcon field="competitionName" />
                </th>
                <th pSortableColumn="ordinaryCount" class="table__header">
                  Inscritos Ordinarios <p-sortIcon field="ordinaryCount" />
                </th>
                <th pSortableColumn="extraordinaryCount" class="table__header">
                  Inscritos Extraordinarios
                  <p-sortIcon field="extraordinaryCount" />
                </th>
                <th pSortableColumn="totalAmount" class="table__header">
                  Total Pagado <p-sortIcon field="totalAmount" />
                </th>
                <th pSortableColumn="statusLabel" class="table__header">
                  Concepto <p-sortIcon field="statusLabel" />
                </th>
                <th pSortableColumn="verificationDate" class="table__header">
                  Fecha Verificación <p-sortIcon field="verificationDate" />
                </th>
                <th pSortableColumn="verifiedBy" class="table__header">
                  Verificado Por <p-sortIcon field="verifiedBy" />
                </th>
                <th class="table__header">Observaciones</th>
                <th class="table__header">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-verifiedPayment>
              <tr class="table__row">
                <td>
                  {{ verifiedPayment.clubName }}
                  <small class="history-reference"
                    >Ref. pago: {{ verifiedPayment.paymentId }}</small
                  >
                </td>
                <td>{{ verifiedPayment.competitionName }}</td>
                <td>{{ verifiedPayment.ordinaryCount }}</td>
                <td>{{ verifiedPayment.extraordinaryCount }}</td>
                <td>{{ verifiedPayment.totalAmount | number }}</td>
                <td>
                  <p-tag
                    [value]="verifiedPayment.statusLabel"
                    [severity]="verifiedPayment.statusSeverity"
                  ></p-tag>
                </td>
                <td>{{ verifiedPayment.verificationDate }}</td>
                <td>{{ verifiedPayment.verifiedBy }}</td>
                <td class="history-comments">
                  {{ verifiedPayment.comments || '—' }}
                </td>
                <td>
                  <p-button
                    icon="pi pi-users"
                    [rounded]="true"
                    [text]="true"
                    severity="info"
                    [raised]="true"
                    class="table__button"
                    pTooltip="Inscripciones Asociadas"
                    tooltipPosition="bottom"
                    (onClick)="openRegistrations(verifiedPayment)"
                  />
                  <p-button
                    icon="pi pi-file"
                    [rounded]="true"
                    [text]="true"
                    [raised]="true"
                    severity="warning"
                    class="table__button"
                    pTooltip="Ver Soporte"
                    tooltipPosition="bottom"
                    (onClick)="showSupport(verifiedPayment)"
                  />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10">
                  Aún no hay pagos manuales verificados para mostrar.
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between">
                {{ filteredVerifiedPayments.length }} verificaciones en total.
              </div>
            </ng-template>
          </p-table>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  
  <p-dialog
    *ngIf="showDocumentPreview"
    [header]="documentPreviewSelected.documentName"
    [(visible)]="showDocumentPreview"
    [modal]="true"
    [style]="{ width: '90vw', height: '100vh' }"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="true"
  >
    <iframe
      allowfullscreen
      [src]="documentPreviewSelected.base64"
      [title]="documentPreviewSelected.documentName"
      class="responsive-iframe"
    ></iframe>
  </p-dialog>
  
  <p-dialog
    *ngIf="showVinculationDetails"
    [header]="'Inscritos asociados al pago'"
    [(visible)]="showVinculationDetails"
    [modal]="true"
    [style]="{ width: '90vw', height: '100vh' }"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="true"
  >
    <div class="lpa-modal-table-container">
      <div class="orphan-warning" *ngIf="orphanRegistrationsCount > 0">
        <i class="pi pi-exclamation-triangle"></i>
        <span>
          {{ orphanRegistrationsCount }} de
          {{ registrationsOfPaymentDetail.length }} inscripciones pagadas no
          tienen deportista asociado: el club los eliminó de su escuela después
          de inscribirlos. La inscripción y su pago siguen siendo válidos, pero
          los datos del deportista ya no están disponibles.
        </span>
      </div>

      <p-table
        #dt
        [value]="registrationsOfPaymentDetail"
        [rows]="10"
        [paginator]="true"
        [globalFilterFields]="[
          'name',
          'lastName',
          'idType',
          'idNumber',
          'clubName',
          'statusLabel'
        ]"
        responsiveLayout="stack"
        [breakpoint]="'960px'"
        [rowHover]="true"
        dataKey="ApplicationId"
        styleClass="lpa-modal-table"
        [rowsPerPageOptions]="[5,10,20]"
        currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
        [showCurrentPageReport]="true"
      >
      <ng-template pTemplate="caption">
        <div class="modal-table-caption">
          <div class="modal-table-caption__actions">
            <button
              pButton
              label="Limpiar Filtros"
              class="p-button-outlined"
              icon="pi pi-filter-slash"
              (click)="clear(dt)"
            ></button>
            <p-button
              icon="pi pi-file-excel"
              label="Exportar inscritos"
              [disabled]="registrationsOfPaymentDetail.length === 0"
              (onClick)="exportRegistrationsOfPayment()"
              pTooltip="Descarga en Excel los inscritos asociados a este pago"
              tooltipPosition="bottom"
            />
          </div>

          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Búsqueda por palabras"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th id="tipoSolicitud" class="table__header-title">
            Tipo Solicitud
  
            <p-columnFilter
              type="text"
              field="type"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Club
  
            <p-columnFilter
              type="text"
              field="club"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="tipoSolicitud" class="table__header-title">
            Modalidad
  
            <p-columnFilter
              type="text"
              field="modalidad"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th id="nombre" class="table__header-title">
            Nombre
            <p-columnFilter
              type="text"
              field="name"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="apellido"
            pSortableColumn="apellido"
            class="table__header-title"
          >
            Apellido
  
            <p-columnFilter
              type="text"
              field="lastName"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="idType"
            pSortableColumn="tipoIdentificacion"
            class="table__header-title"
          >
            Tipo Identificación
          </th>
          <th
            id="idNumber"
            pSortableColumn="numeroIdentificacion"
            class="table__header-title"
          >
            Numero Identificación
  
            <p-columnFilter
              type="text"
              field="idNumber"
              display="menu"
              [showMatchModes]="false"
              matchMode="contains"
              [hideOnClear]="true"
            ></p-columnFilter>
          </th>
          <th
            id="status"
            pSortableColumn="isActive"
            class="table__header-title"
          >
            Estado<p-sortIcon
              field="isActive"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
            id="fechaInscripcion"
            pSortableColumn="created_at"
            class="table__header-title"
          >
            Fecha inscripción
            <p-sortIcon
              field="created_at"
              class="table__header-sortIcon"
            ></p-sortIcon>
          </th>
          <th
          id="tipoInscripcion"
          pSortableColumn="created_at"
          class="table__header-title"
        >
          Tipo inscripción
          <p-sortIcon
            field="tipoInscripcion"
            class="table__header-sortIcon"
          ></p-sortIcon>
        </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr [class.row--orphan]="!row.hasMember">
          <td>
            <span class="p-column-title font-bold">Rol</span>
            {{ row.rol || '—' }}
          </td>
          <td>
            <span class="p-column-title font-bold">Club</span
            >{{ row.clubName }}
          </td>
          <td>
            <span class="p-column-title font-bold">Modalidad</span
            >{{ row.modalidad || '—' }}
          </td>
          <td>
            <span class="p-column-title font-bold">Nombres</span>
            {{ row.name }}
            <p-tag
              *ngIf="!row.hasMember"
              value="Eliminado por el club"
              severity="danger"
            ></p-tag>
          </td>
          <td>
            <span class="p-column-title font-bold">Apellidos</span
            >{{ row.lastName || '—' }}
          </td>
          <td>
            <span class="p-column-title font-bold">Tipo Id</span
            >{{ row.idType || '—' }}
          </td>
          <td>
            <span class="p-column-title font-bold">Id</span>
            {{ row.idNumber || '—' }}
            <small class="orphan-reference" *ngIf="!row.hasMember"
              >Id interno: {{ row.memberId }}</small
            >
          </td>
          <td>
            <span class="p-column-title font-bold">Estado</span>
            {{ row.statusLabel }}
          </td>
          <td>
            <span class="p-column-title font-bold">Fecha Inscripción</span
            >{{ row.registrationDate }}
          </td>
          <td>
            <span class="p-column-title font-bold">Tipo Inscripción</span
            >{{ row.temporalLabel }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          Total de inscripciones {{ registrationsOfPaymentDetail.length }}
          <span *ngIf="orphanRegistrationsCount > 0">
            ({{ orphanRegistrationsCount }} sin deportista asociado)</span
          >.
        </div>
      </ng-template>
      </p-table>
    </div>
  </p-dialog>
  
  <p-dialog
    *ngIf="showRevisionConceptModal"
    [header]="'Emitir concepto de verificación del pago manual'"
    [(visible)]="showRevisionConceptModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="true"
  >
    <div class="confirm-payment__modal">
      <p-selectButton
        [options]="paymentStatusOptions"
        [(ngModel)]="paymentStatusSelected"
        optionLabel="label"
        optionValue="value"
      />
    </div>
    <div
      *ngIf="paymentStatusSelected === 'rejected'"
      class="confirm-payment__rejected"
    >
      <div>
        <span>Indique el motivo del rechazo:</span>
      </div>
      <div>
        <textarea
          rows="5"
          cols="80"
          pInputTextarea
          [(ngModel)]="paymentRejectReason"
        >
        </textarea>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button
        label="Cancelar"
        [text]="true"
        severity="secondary"
        (onClick)="onCancelPaymentResponse()"
      />
      <p-button
        label="Confirmar"
        [outlined]="true"
        severity="primary"
        [disabled]="paymentStatusSelected === 'rejected' && paymentRejectReason.trim().length <= 0"
        (onClick)="onConfirmPaymentResponse()"
      />
    </ng-template>
  </p-dialog>
  